module.exports = __webpack_public_path__ + "index_pc/img/img_notebook.c5329d5f.png";